const PAGINATION_KEY_PREFIX = "table_pagination_";

export const getStoredPageSize = (tableKey: string, fallback: number) => {
  const raw = localStorage.getItem(PAGINATION_KEY_PREFIX + tableKey);
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : fallback;
};

export const setStoredPageSize = (tableKey: string, pageSize: number) => {
  localStorage.setItem(PAGINATION_KEY_PREFIX + tableKey, String(pageSize));
};
